module.exports = __webpack_public_path__ + "static/media/fireplace (1).2b2be457.svg";